export default "__VITE_ASSET__53f0478d__"